export default __webpack_public_path__ + "static/Plots0021-dd067d5fd897f0788dd7d81bbaefc1a4.jpg";